import axiosApi from "./index"
let chainIndex = {
  // site: () => {
  //   return axiosApi({
  //     method: "get",
  //     url: "http://localhost:3000/comments",
  //   })
  // },
  
analogInterface: (projectId) => {
    return axiosApi({
      method: "get",
      url: "http://192.168.33.127:37086/loop/all",
      params: {
                projectId
              },
    })
  },
  
}
// /alarm/event/num/ranking
// let chainIndex = {
//   site: (projectId) => {
//     return axiosApi({
//       method: "get",
//       url: "https://local.vrmaker.vip:37086/area/project/all",
//       params: {
//         projectId
//       },
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//         Header: { "Authorization": "VrMakerToken"}
//       },
//     })
//   }
// }
export default chainIndex